import request from '@/utils/request'

// ============ 菜品管理 API ============
export const getDishList = (params) => {
    return request.get('/houtai/htgetUserDishes', { params })
}



// ============ 图片管理 API ============

// 1. 获取图片列表（分页 + 条件查询）
export const getImageList = (params) => {
    return request.get('/houtai/admin/image-check/list', { params })
}

// 2. 删除数据库中的检测记录（硬删除）
export const deleteImageRecord = (data) => {
    return request.post('/houtai/admin/delete-record', data)
}

// 3. 清除打卡图片（清除 yb_user_dishes 表中的 custom_image）
export const clearDakaImage = (data) => {
    return request.post('/houtai/admin/clear-daka-image', data)
}

// 4. 批量删除所有已删除的数据
export const deleteAllDeletedImages = () => {
    return request.post('/houtai/admin/delete-all-deleted')
}